"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TablerowSubText = exports.TablerowText = exports.TextContainer = exports.LeftImageView = exports.InnerContainer = exports.MoreInfoExpandedWrapper = exports.Accordion = void 0;
const native_1 = __importDefault(require("styled-components/native"));
const react_native_1 = require("react-native");
const phoneWidth = react_native_1.Dimensions.get('screen').width > 320 ? 32 : 24;
exports.Accordion = native_1.default.TouchableOpacity `
  justify-content: space-between;
  align-items: center;
  height: 67px;
  flex-direction: row;
  border-color: #dddddd;
  background-color: ${({ theme }) => theme.color.white};
  border-top-width: 0.5px;
  border-bottom-width: 0.5px;
`;
exports.MoreInfoExpandedWrapper = native_1.default.View `
  padding: 15px;
  margin-left: 0px;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 42px;
`;
exports.InnerContainer = native_1.default.View `
  justify-content: flex-start;
  align-items: center;
  height: 67px;
  flex-direction: row;
  flex-shrink: 1;
`;
exports.LeftImageView = native_1.default.View `
  width: 24px;
  justify-content: center;
  align-items: center;
  padding-left: ${phoneWidth}px;
`;
exports.TextContainer = native_1.default.View `
  flex-direction: column;
  justify-content: center;
`;
exports.TablerowText = native_1.default.Text `
  text-align: left;
  font-size: 16px;
  align-items: flex-start;
  padding-left: 25px;
`;
exports.TablerowSubText = native_1.default.Text `
  text-align: left;
  font-size: 12px;
  color: gray;
  align-items: flex-start;
  padding-left: 25px;
`;
